import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=6a7fbf7d&scoped=true&"
import script from "./QuotationList.vue?vue&type=script&lang=js&"
export * from "./QuotationList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=6a7fbf7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fbf7d",
  null
  
)

export default component.exports